import { createPortal } from 'react-dom'

/**
 * 전체 화면 차단 로딩 오버레이(`#879`) — 이미지 업로드처럼 완료 전까지 다른 조작을 막아야 하는 진행
 * 상태에 쓴다. `Modal.tsx`의 포털+반투명 배경 패턴을 재사용하되, 대화상자가 아니라 상태 표시이므로
 * `role="dialog"` 대신 `role="status"`를 쓴다. 신규 의존성 없이 Tailwind `animate-spin`만으로 스피너를
 * 그린다(스켈레톤 기반 `LoadingState`와 달리, 화면 전체를 덮어 클릭·터치를 막는 용도라 별도 컴포넌트로 둔다).
 *
 * `document.body`에 포털로 렌더한다 — `Card` 레이아웃 안에 중첩되면 `overflow`/`z-index`로 잘릴 수 있다.
 */
export function LoadingOverlay({ label }: { label: string }) {
  return createPortal(
    <div
      role="status"
      aria-label={label}
      aria-live="polite"
      aria-busy="true"
      className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-3 bg-ink-700/40"
    >
      <span
        aria-hidden="true"
        className="h-10 w-10 animate-spin rounded-full border-4 border-white/30 border-t-white"
      />
      <span className="text-sm font-medium text-white">{label}</span>
    </div>,
    document.body
  )
}
